<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <div class="title-page-text">
                {{ $t('v2.select_delivery_method') }}
              </div>
              <v-spacer />
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-2">
            <div v-if="showPrivateCourier" class="flex-image py-2 cursor-pointer" @click="selectShipping()">
              <div class="mr-2 d-flex">
                <img src="@/assets/images/v2/img/icon_restaurant_courier.png" :alt="$t('v2.restaurant_courier')" class="image-40 br-8">
              </div>
              <div class="flex-image-content">
                <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                  {{ $t('v2.restaurant_courier') }}
                </div>
                <div v-if="!$isEmpty($store.state.selected_outlet) && amountOrder < Number($store.state.selected_outlet.delivery.minimum_order)" class="ol-accent font-12 line-height-normal">
                  {{ $t('v2.get_free_delivery') }} <span v-mask-money="Number($store.state.selected_outlet.delivery.minimum_order) - amountOrder" />
                </div>
                <div v-else-if="locations.shipping_radius > $store.state.selected_outlet.delivery.radius_free_delivery" class="ol-grey-content font-12 line-height-normal">
                  {{ $t('v2.there_is_an_additional_charge', { radius: $store.state.selected_outlet.delivery.radius_free_delivery }) }}
                </div>
              </div>
              <div v-if="priceCourier === 0" class="font-14 font-weight-600 ol-black ml-3">
                {{ $t('v2.free') }}
              </div>
              <div v-else v-mask-money="priceCourier" class="font-14 font-weight-600 ol-black ml-3" />
            </div>
            <template v-for="(item, idx) in list_shipping">
              <div v-if="list_shipping.length > 0" :key="idx + '-line'" class="div-line" />
              <div v-if="list_shipping.length > 0" :key="idx + '-item'">
                <div :class="['flex-image py-2 cursor-pointer', { 'disabled': timeShipper(item).disabled && timeShipper(item).limited_time }]" @click="!timeShipper(item).disabled && selectShipping(item, 2)">
                  <div class="mr-2 d-flex">
                    <img :src="item.image_url" :alt="item.type" class="image-40 br-8">
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                      {{ item.logistic_name }}
                    </div>
                    <div v-if="timeShipper(item).limited_time" :class="['font-12', { 'warning--text': timeShipper(item).end_soon }]" v-html="timeShipper(item).text" />
                  </div>
                  <div v-mask-money="item.final_price" class="font-14 font-weight-600 ol-black" />
                </div>
              </div>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  getDataShippingV2
} from '@/api/order'
export default {
  data() {
    return {
      locations: {},
      list_shipping: [],
      cart: {},
      shipping: {}
    }
  },
  computed: {
    priceCourier() {
      let price = 0
      if (typeof this.cart.item !== 'undefined' && this.cart.item.length > 0) {
        const arrItem = []
        for (const i in this.cart.item) {
          arrItem.push(this.cart.item[i].sub_total)
        }
        if (!this.$isEmpty(this.$store.state.selected_outlet) && this.amountOrder < Number(this.$store.state.selected_outlet.delivery.minimum_order)) {
          price = this.locations.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius
        } else if (this.locations.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
          price = (this.locations.shipping_radius - this.$store.state.selected_outlet.delivery.radius_free_delivery) * this.$store.state.selected_outlet.delivery.cost_outside_radius
        }
      }
      return price
    },
    amountOrder() {
      let amount = 0
      if (typeof this.cart.item !== 'undefined' && this.cart.item.length > 0) {
        const arrItem = []
        for (const i in this.cart.item) {
          arrItem.push(this.cart.item[i].sub_total)
        }
        for (var el in arrItem) {
          if (arrItem.hasOwnProperty(el)) {
            amount += parseFloat(arrItem[el])
          }
        }
      }
      return amount
    },
    showPrivateCourier() {
      if (!this.$isEmpty(this.$store.state.selected_outlet)) {
        if (this.$store.state.selected_outlet.delivery.turn_off_private_courier) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  mounted() {
    const LOCAL_DATA_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
    if (LOCAL_DATA_LOCATION) {
      this.locations = JSON.parse(LOCAL_DATA_LOCATION)
    }
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    this.getDeliveryMethod()
  },
  methods: {
    goBack() {
      this.$router.push({ name: '_checkout' }).catch(() => {})
    },
    async getDeliveryMethod() {
      try {
        const form = {
          shipping_lat: this.locations.shipping_lat,
          shipping_lon: this.locations.shipping_lon,
          item: this.cart.item
        }
        const { data } = await getDataShippingV2(form)
        this.list_shipping = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    selectShipping(item = {}, id = 1) {
      var select_store = this.$store.state.selected_store
      if (this.$store.state.selected_outlet) {
        select_store = this.$store.state.selected_outlet
      }
      this.shipping.shipping_delivery_type = id
      if (id === 2) {
        this.shipping.shipping_cost = item.final_price
        this.shipping.shipping_courier_id = item.rate_id
        this.shipping.shipping_logo = item.image_url
        this.shipping.shipping_courier_name = item.logistic_name
        this.$store.dispatch('saveShippingV2', this.shipping)
        this.$router.push({ name: '_checkout' }).catch(() => {})
      } else if (id === 1) {
        if (this.locations.shipping_radius > select_store.delivery.max_radius_delivery) {
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.you_are_outside_the_store_delivery_limits')
          this.$store.state.error_type = 400
        } else {
          if (!this.$isEmpty(this.$store.state.selected_outlet) && this.totalPriceItem < Number(this.$store.state.selected_outlet.delivery.minimum_order)) {
            if (this.locations.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
              this.shipping.shipping_cost = this.locations.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius
            } else {
              this.shipping.shipping_cost = this.locations.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius
            }
          } else {
            if (this.locations.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
              this.shipping.shipping_cost = (this.locations.shipping_radius - this.$store.state.selected_outlet.delivery.radius_free_delivery) * this.$store.state.selected_outlet.delivery.cost_outside_radius
            } else {
              this.shipping.shipping_cost = 0
            }
          }
          this.shipping.shipping_courier_id = null
          this.shipping.shipping_logo = require('@/assets/images/v2/img/icon_restaurant_courier.png')
          this.shipping.shipping_courier_name = this.$t('v2.restaurant_courier')
          this.$store.dispatch('saveShippingV2', this.shipping)
          this.$router.push({ name: '_delivery_time' }).catch(() => {})
        }
      }
    },
    timeShipper(item) {
      const obj = {
        limited_time: false,
        end_soon: false,
        disabled: false,
        text: ''
      }
      if (!this.$isEmpty(item.time_oprational) && item.time_oprational.open_time !== '' && item.time_oprational.close_time !== '') {
        obj.limited_time = true
        obj.text = this.$t('available_time', { time: item.time_oprational.open_time + ' - ' + item.time_oprational.close_time })
      }

      const today = new Date()
      const hours = today.getHours()
      const minutes = today.getMinutes()
      const arrCloseTime = typeof item.time_oprational.close_time !== 'undefined' ? item.time_oprational.close_time.split(':') : []
      if (hours >= Number(arrCloseTime[0])) {
        obj.end_soon = true
        obj.text = this.$t('end_soon', { time: (arrCloseTime[1] - minutes) })
      }
      if (hours >= (Number(arrCloseTime[0]) + 1)) {
        obj.disabled = true
        obj.text = ''
      } else if (hours === Number(arrCloseTime[0]) && minutes > Number(arrCloseTime[1])) {
        obj.disabled = true
        obj.text = ''
      }
      return obj
    }
  }
}
</script>
